import { ARBITRUM_FARM_STATE } from "./arbitrum";
import { BLAST_FARM_STATE } from "./blast";
import { MAINNET_FARM_STATE } from "./mainnet";
import { FarmState } from "./types";

export const FARM_STATE: Record<number, FarmState> = {
  1: MAINNET_FARM_STATE,
  42161: ARBITRUM_FARM_STATE,
  81457: BLAST_FARM_STATE,
};
